<template>
    <div v-if="numberOfItems > 1" class="pagination__container">
        <button class="pagination__nav" type="button" :disabled="previuousDisabled" @click="previuous">
            <span>
                <common-icon name="arrow-left-blue" size="huge"></common-icon>
            </span>
            <span>&lt; {{ $t('common.pagination.previous') }}</span>
        </button>
        <div class="pagination__arrow">
            <div v-if="showFirst" class="pagination__max-number pagination--ml15">
                1
            </div>
            <div v-if="showFirst" class="pagination__points pagination--ml10">
                ...
            </div>
        </div>
        <div v-for="(number, index) in buttons" :key="index" :class="paginationButtonClass(number)">
            {{ number }}
        </div>
        <div class="pagination__arrow">
            <div v-if="showLast" class="pagination__points pagination--mr10">
                ...
            </div>
            <div v-if="showLast" class="pagination__max-number pagination--mr15">
                {{ numberOfItems }}
            </div>
        </div>
        <button class="pagination__nav" type="button" :disabled="nextDisabled" @click="next">
            <span>
                <common-icon name="arrow-right-blue" size="huge"></common-icon>
            </span>
            <span>{{ $t('common.pagination.next') }} ></span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            numberOfItems: { type: Number, required: true },
        },

        data() {
            return {
                selectedIndex: 1,
                buttons: [],
            }
        },

        computed: {
            showFirst() {
                return !this.buttons.includes(1)
            },
            showLast() {
                return !this.buttons.includes(this.numberOfItems)
            },
            previuousDisabled() {
                return this.selectedIndex === 1
            },
            nextDisabled() {
                return this.selectedIndex === this.numberOfItems
            },
        },

        methods: {
            paginationButtonClass(number) {
                return {
                    pagination__button: true,
                    'pagination__button--selected': number === this.selectedIndex,
                }
            },
            next() {
                if (this.selectedIndex !== 1 && this.selectedIndex + 1 !== this.numberOfItems) {
                    this.buttons = this.buttons.map((element) => element + 1)
                }
                this.selectedIndex = this.selectedIndex + 1
                this.emitEvent({ name: 'page-changed', payload: this.selectedIndex })
            },
            previuous() {
                if (this.selectedIndex !== this.numberOfItems && this.selectedIndex - 1 !== 1) {
                    this.buttons = this.buttons.map((element) => element - 1)
                }
                this.selectedIndex = this.selectedIndex - 1
                this.emitEvent({ name: 'page-changed', payload: this.selectedIndex })
            },
        },

        mounted() {
            const buttons = []
            const numberOfButtons = this.numberOfItems > 3 ? 3 : this.numberOfItems
            for (let i = 1; i <= numberOfButtons; i++) {
                buttons.push(i)
            }
            this.buttons = buttons
        },
    }
</script>
